import { Modal } from "antd";
import { Template, WorkOrder } from "../../api/models";
import Create from "./create";
import Rename from "./rename";
import UploadParameters from "./upload-parameters";
import UploadAssets from "./upload-assets";
import Status from "./status";
import Results from "./results";

export enum WorkOrderFunction {
  None = "None",
  Create = "Create",
  UploadParameters = "UploadParameters",
  UploadAssets = "UploadAssets",
  ViewStatuses = "ViewStatuses",
  ViewResults = "ViewResults",
  Rename = "Rename"
}

interface WorkOrderParams {
  workOrderFunction: WorkOrderFunction,
  template?: Template,
  workOrder?: WorkOrder,
  onClose: () => void
  onSave: (workOrder: WorkOrder) => void,
  onCreate: (workOrder: WorkOrder) => void
};

export default function (p: WorkOrderParams) {
  const isOpen = p.workOrderFunction !== WorkOrderFunction.None;
  return (
    <Modal
      open={isOpen}
      closable={false}
      onCancel={p.onClose}
    >
      {
        p.workOrderFunction === WorkOrderFunction.Create ?
          <Create
            template={p.template}
            onClose={p.onClose}
            onCreate={p.onCreate}
          /> : undefined
      }
      {
        p.workOrderFunction === WorkOrderFunction.UploadParameters ?
          <UploadParameters
            workOrder={p.workOrder}
            onClose={p.onClose}
            onSave={p.onSave}
          /> : undefined
      }
      {
        p.workOrderFunction === WorkOrderFunction.UploadAssets ?
          <UploadAssets
            workOrder={p.workOrder}
            onClose={p.onClose}
            onSave={p.onSave}
          /> : undefined
      }
      {
        p.workOrderFunction === WorkOrderFunction.ViewStatuses ?
          <Status
            workOrder={p.workOrder}
            onClose={p.onClose}
            onSave={p.onSave}
          /> : undefined
      }
      {
        p.workOrderFunction === WorkOrderFunction.ViewResults ?
          <Results
            workOrder={p.workOrder}
            onClose={p.onClose}
          /> : undefined
      }
      {
        p.workOrderFunction === WorkOrderFunction.Rename ?
          <Rename
            workOrder={p.workOrder}
            onClose={p.onClose}
            onSave={p.onSave}
          /> : undefined
      }
    </Modal>
  );
}